// extracted by mini-css-extract-plugin
export default {"statsContainer":"OrderStats_statsContainer__5jQJv","statCard":"OrderStats_statCard__L6tm8","statItem":"OrderStats_statItem__ZNDZK"};